<template>
  <el-collapse v-model="activeNames" class="payee-match-usage-guide">
    <el-collapse-item name="guide">
      <template slot="title">
        <span class="guide-title">
          <i class="el-icon-question"/>
          {{ $t('text.payeeMatchUsageGuide') }}
        </span>
      </template>
      <div class="guide-body">
        <p class="guide-intro">{{ $t('message.payeeMatchGuideIntro') }}</p>
        <ol class="guide-steps">
          <li v-for="(step, index) in steps" :key="index">{{ step }}</li>
        </ol>
      </div>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
export default {
  name: "PayeeMatchUsageGuide",
  props: {
    /** edit=编辑页段落，dialog=弹窗，import=批量导入 */
    scene: {
      type: String,
      default: "dialog"
    },
    /** 是否默认展开 */
    defaultOpen: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      activeNames: this.defaultOpen ? ["guide"] : []
    };
  },
  computed: {
    steps() {
      const keys = this.scene === "import"
          ? [
            "message.payeeMatchGuideImport1",
            "message.payeeMatchGuideImport2",
            "message.payeeMatchGuideImport3",
            "message.payeeMatchGuideImport4"
          ]
          : [
            "message.payeeMatchGuideStep1",
            "message.payeeMatchGuideStep2",
            "message.payeeMatchGuideStep3",
            "message.payeeMatchGuideStep4"
          ];
      return keys.map(key => this.$t(key));
    }
  }
};
</script>

<style scoped>
.payee-match-usage-guide {
  margin-bottom: 16px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
}

.payee-match-usage-guide >>> .el-collapse-item__header {
  height: 40px;
  line-height: 40px;
  padding: 0 12px;
  background: #f5f7fa;
  font-size: 13px;
}

.payee-match-usage-guide >>> .el-collapse-item__wrap {
  background: #fafbfc;
}

.payee-match-usage-guide >>> .el-collapse-item__content {
  padding: 8px 16px 12px;
}

.guide-title {
  color: #409eff;
  font-weight: 500;
}

.guide-title i {
  margin-right: 4px;
}

.guide-intro {
  margin: 0 0 8px;
  color: #606266;
  font-size: 13px;
  line-height: 1.5;
}

.guide-steps {
  margin: 0;
  padding-left: 20px;
  color: #606266;
  font-size: 13px;
  line-height: 1.7;
}

.guide-steps li {
  margin-bottom: 2px;
}
</style>
